import CarouselSwiper, {
    NavigationControls,
    useCarouselSwiperController,
} from '@eventbrite/eds-carousel-swiper';
import { EventCard, FormattedEvent } from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { USER_WEEKEND_INPERSON_EVENTS } from '../../constants/constants';
import peopleImg from '../../static/images/weekendBucket/people-illustration.png';
import { useWindowWidth } from '../../utils/dom';
import { getLocationInfo } from '../../utils/venue';
import './WeekendBucket.scss';

interface WeekendBucketProps {
    initialIsVisible?: boolean;
    emptyStateStyles?: Object;
    onEnter?: Function;
    bottomOffset?: string;
    onIsVisible?: Function;
    events: Array<FormattedEvent>;
}

export const WeekendBucket: React.FunctionComponent<WeekendBucketProps> = (
    props,
) => {
    const windowWidth = useWindowWidth();
    const isMobile = (windowWidth || 0) <= 480;
    const isTablet = !isMobile && (windowWidth || 0) <= 960;
    const { events } = props;
    const items = events?.map((event) => {
        const formattedEvent = {
            ...event,
            locationInfo:
                getLocationInfo(
                    event.venue?.name,
                    event.venue?.address?.localizedAreaDisplay,
                )?.toString() || '',
        };
        return (
            <EventCard
                key={event.id}
                eventData={formattedEvent}
                isAuthenticated={true}
                affCode={USER_WEEKEND_INPERSON_EVENTS}
            />
        );
    });

    const {
        isLastSlide,
        nextSlide,
        prevSlide,
        currentIndex,
        isFirstSlide,
        setCurrentIndex,
    } = useCarouselSwiperController({
        initialSlide: 0,
        items: items || [],
    });

    return (
        <section className="weekend-bucket">
            <div className="weekend-bucket__wrapper">
                <div className="weekend-bucket__intro">
                    <div className="weekend-bucket__intro__content">
                        <img
                            src={peopleImg}
                            alt="Illustration of people gathered together"
                            aria-hidden="true"
                        />
                        <Typography
                            className="weekend-bucket__title"
                            variant="display-md"
                            as="h3"
                        >
                            {gettext('Your weekend guide')}
                        </Typography>
                        <Typography className="weekend-bucket__subtitle">
                            {gettext(
                                'Make the perfect plans with these recommendations.',
                            )}
                        </Typography>
                    </div>
                </div>
                <div className="weekend-bucket__carousel">
                    <CarouselSwiper
                        className="weekend-bucket__carousel__swiper"
                        controls={
                            !isMobile ? (
                                <NavigationControls
                                    className="weekend-bucket__carousel__controls"
                                    isFirstSlide={isFirstSlide}
                                    isLastSlide={isLastSlide}
                                    nextSlide={nextSlide}
                                    prevSlide={prevSlide}
                                    setCurrentIndex={setCurrentIndex}
                                />
                            ) : null
                        }
                        currentIndex={currentIndex}
                        enableNavigationLooping
                        items={items}
                        setCurrentIndex={setCurrentIndex}
                        useBottomProgressBar={true}
                        disableNextSlides={isMobile || !isTablet}
                        animateSlides={true}
                        snapToEndPosition={
                            isMobile
                                ? `-${items.length - 2}88%`
                                : `-${items.length - 2}20%`
                        }
                        hidePreviousSlide={true}
                    />
                </div>
            </div>
        </section>
    );
};
